var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHambuergerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.2238C0 12.8556 0.298477 12.5571 0.666667 12.5571H19.3333C19.7015 12.5571 20 12.8556 20 13.2238C20 13.592 19.7015 13.8905 19.3333 13.8905H0.666667C0.298477 13.8905 0 13.592 0 13.2238Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.99967C0 6.63148 0.298477 6.33301 0.666667 6.33301H19.3333C19.7015 6.33301 20 6.63148 20 6.99967C20 7.36786 19.7015 7.66634 19.3333 7.66634H0.666667C0.298477 7.66634 0 7.36786 0 6.99967Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.778483C0 0.410293 0.298477 0.111816 0.666667 0.111816H19.3333C19.7015 0.111816 20 0.410293 20 0.778483C20 1.14667 19.7015 1.44515 19.3333 1.44515H0.666667C0.298477 1.44515 0 1.14667 0 0.778483Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHambuergerIcon);
export default __webpack_public_path__ + "static/media/hambuergerIcon.7798d990ec38fbdf4eee3a6aae718ff4.svg";
export { ForwardRef as ReactComponent };